import * as Square from "@square/web-sdk";
import React, { useCallback, useEffect, useState } from "react";

import { Loader } from "@whoosh/design-system/src/components/display";
import { Box } from "@whoosh/design-system/src/components/primitive";

import { useAttachSquareCard } from "./hooks/useAttachSquareCard";
import { useGetSQUIPForWeb } from "./hooks/useGetSQUIPForWeb";
import { useSquareFormValidity } from "./hooks/useSquareFormValidity";

export const SquareCardEntry = ({
  setLoading,
  loading,
  card,
  setCard,
  onFormValidityChange,
}: {
  setLoading: (loading: boolean) => void;
  card: Square.Card | undefined;
  setCard: (card: Square.Card | undefined) => void;
  loading: boolean;
  onFormValidityChange?: (isValid: boolean) => void;
}) => {
  const squareApplicationId = useGetSQUIPForWeb();
  const [cardContainer, setCardContainer] = useState<HTMLDivElement | null>(
    null
  );

  const setCardContainerRef = useCallback((node: HTMLDivElement | null) => {
    setCardContainer(node);
  }, []);

  useAttachSquareCard({
    squareApplicationId,
    card,
    setCard,
    setLoading,
    container: cardContainer,
  });

  const isFormValid = useSquareFormValidity(card);

  useEffect(() => {
    onFormValidityChange?.(isFormValid);
  }, [isFormValid, onFormValidityChange]);

  return (
    <Box
      id="payment-form"
      testID="square-card-entry-modal-web"
      data-sentry-mask
      flex={1}
      width="100%"
    >
      {loading ? (
        <Box
          minHeight={137}
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          flex={1}
          zIndex={1000}
        >
          <Loader />
        </Box>
      ) : null}
      {/* This is where the Square Card will be attached */}
      <div
        ref={setCardContainerRef}
        style={{ flex: 1, minHeight: 137, width: "100%" }}
      />
      {/* 137 pixels is the height of the container*/}
    </Box>
  );
};
